export const applyFixedBodySetting = (body, isFixed, bodyTypes = Box2D) => {
    body.SetType(isFixed ? bodyTypes.b2_staticBody : bodyTypes.b2_dynamicBody);
};
